import { useState, useEffect } from "react";
import seoData from "../data/seoData";
import JsonData from "../data/data.json";

const getCurrentSection = (offset = 0) => {
  const sections = document.querySelectorAll("section[id]");
  const scrollPosition = window.scrollY + offset;

  for (const section of sections) {
    const sectionTop = section.offsetTop;
    const sectionBottom = sectionTop + section.offsetHeight;

    if (scrollPosition >= sectionTop && scrollPosition < sectionBottom) {
      return section.id;
    }
  }

  return ""; // homepage
};

const useSectionManager = (offset = 0) => { // customizable offset
  const [activeSection, setActiveSection] = useState("");

  useEffect(() => {
    const handleScroll = () => {
      const section = getCurrentSection(offset);

      if (section !== activeSection) {
        setActiveSection(section);

        // Update slug
        const newPath = section ? `/${section}` : "/";
        if (window.location.pathname !== newPath) {
          window.history.replaceState(null, "", newPath);
        }

        // Update SEO
        const { title, description } = seoData[section] || seoData[""];
        document.title = title;
        const metaDescription = document.querySelector("meta[name='description']");
        if (metaDescription) {
          metaDescription.setAttribute("content", description);
        }

        // Update canonical
        const canonicalUrl = section === ""
          ? JsonData.baseUrl
          : `${JsonData.baseUrl}/${section}`;
        const linkCanonical = document.querySelector("link[rel='canonical']");
        if (linkCanonical) {
          linkCanonical.setAttribute("href", canonicalUrl);
        }
      }
    };

    handleScroll(); // init on mount
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [activeSection, offset]);

  return activeSection;
};

export default useSectionManager;
